import { QueryClient, useQueryClient } from '@tanstack/react-query'
import { useMemo } from 'react'
import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import { createProtectedRoutes } from '@/routes/protectedRoutes'
import { createPublicRoutes } from '@/routes/publicRoutes'

export const createAppRouter = (queryClient: QueryClient) =>
  createBrowserRouter([createProtectedRoutes(queryClient), ...createPublicRoutes(queryClient)])

export const AppRouter = () => {
  const queryClient = useQueryClient()
  const router = useMemo(() => createAppRouter(queryClient), [queryClient])
  return <RouterProvider router={router} />
}
